import { gql } from 'graphql-request'

const FIELDS = `
  id
  liveCheckinMonthId
  liveCheckinLevelId
  liveCheckinLevelRewardId
  userId
  liveCheckinRewardType
  rewardAmount
  itemId
  durationInDay
  unlocked
  unlockedAt
  received
  dateReceived
`

export const GET_LIVE_CHECKINS_MONTHS_LEVELS_REWARDS = gql`
  query GET_LIVE_CHECKINS_MONTHS_LEVELS_REWARDS(
    $take: Int
    $skip: Int
    $liveCheckinMonthId: Int
    $userId: Int
    $unlocked: Boolean
    $received: Boolean
  ) {
    getLiveCheckinsMonthsLevelsRewards(
      take: $take
      skip: $skip
      liveCheckinMonthId: $liveCheckinMonthId
      userId: $userId
      unlocked: $unlocked
      received: $received
    ) {
      status
      error
      totalPages
      data { ${FIELDS} }
    }
  }
`

export const CLAIM_LIVE_CHECKIN_MONTH_LEVEL_REWARD = gql`
  mutation CLAIM_LIVE_CHECKIN_MONTH_LEVEL_REWARD(
    $liveCheckinMonthLevelRewardId: Int!
  ) {
    claimLiveCheckinMonthLevelReward(
      liveCheckinMonthLevelRewardId: $liveCheckinMonthLevelRewardId
    ) {
      status
      error
      data { ${FIELDS} }
    }
  }
`
